//export const BASE_URL = window.globalConfig.BASE_URL;//'http://dataseps.gecko.com.ec/api/api';
export const BASE_URL = window.globalConfig.BASE_URL;
export const HOME_URL = window.globalConfig.HOME_URL;
export const SERVICE_URL= window.globalConfig.SERVICE_URL;